import Vue from "vue";
import {
    PUT_PLACES,
} from "./types";

export default {
    [PUT_PLACES]: (state, places) => {
        Vue.set(state, 'places', places);
    },
};